import { Avatar, Button, Grid, Paper, TextField } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import React, { useState } from 'react';
import logoWhite from '../assets/logo-icon-white.png'
import { MobileNumberValidation } from '../utils/MobileNumberCheck';
import { setAuth, setAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from './MaterialNotifyComponent';
import headerLogo from '../assets/Logo_login.png';
import drailLogo from '../assets/Dreil.png';

function Login(props) {
    const mainDivStyle = {
        margin: '0',
        textAlign: 'center',
        backgroundColor: '#0072bc',
        color: 'white',
        width: '100%',
        minHeight: '100vh'
    };
    const headerDivStyle = {
        backgroundColor: '#ffffff',
        height: '50px',
        display: 'flex'
    };
    const leftHeaderSection = {
        display: "inline",
        width: "50%",
        height: "50px",
        borderTopRightRadius: "40px",
        backgroundImage: "linear-gradient(60deg, #ffffff, #eeeeee, #cccccc)"
    };
    const centerHeaderSection = {
        display: ["inline", "inline-flex"],
        width: "400px",
        height: "50px",
        color: "#0072bc",
        alignItems: "center"
    };
    const centerHeaderText = { margin: 'auto' };
    const rightHeaderSection = {
        display: "inline",
        width: "50%",
        height: "50px",
        borderTopLeftRadius: "40px",
        backgroundImage: "linear-gradient(-60deg, #ffffff, #eeeeee, #cccccc)"
    };
    const headerLogoSection = { background: "#0072bc", height: "100px", display: "flex" };
    const headerLogoSideSection = { display: "inline", width: "50%", height: "100px" };
    const headerLogoCenterSection = {
        display: ["inline", "inline-flex"],
        background: "#ffffff",
        width: "400px",
        height: "100px",
        borderRadius: "0px 0px 20px 20px",
        alignItems: "center"
    };
    const logoImage = {
        width: "90%",
        display: "inline-block",
        margin: "auto",
        verticalAlign: "middle"
    };
    const headerText = {
        alignItems: "center",
        direction: "rtl",
        lineHeight: "0.7rem"
    };
    const headerEnglishText = { fontFamily: "Verdana, Geneva, Tahoma, sans-serif", fontSize: "19px" };
    const headerPersianText = { fontSize: "23px" };
    const headerPersianTextNumber = { color: "yellow", fontWeight: "bolder" };
    const dreilContainer = {
        height: "260px",
        display: "inline-flex",
        alignItems: "center"
    };
    const dreilImage = {
        width: "200px",
        display: "inline-block",
        margin: "auto",
        verticalAlign: "middle"
    };
    const buttonStyle = { color: '#ffffff' };
    const paperStyle = {
        padding: 20,
        width: 250,
        margin: 'auto',
        overflow: 'auto',
        backgroundColor: 'transparent !important'
    };
    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            }
        }
    }));

    const classes = useStyles();

    //State----------------------------------------------------------------------------------
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    //---------------------------------------------------------------------------------------

    const loginHandler = (e) => {
        let mobileObject = MobileNumberValidation(userName);
        if (mobileObject.isValid) {
            axios.post('api/v2/Authorization/WebLogin', {
                userName: mobileObject.validNumber,
                password: password
            }).then(response => {
                if (response.data && response.data.access_token !== "Wrong Code") {
                    setAuthenticationToken(response.data);
                    setAuth(response.data.access_token);
                    props.history.push('/');
                }
                else if (response.data.access_token === "Wrong Code") {
                    setMessageNotify({
                        severity: "warning",
                        message: "نام کاربری و کلمه عبور وارد شده صحیح نمی باشد",
                        open: true
                    });
                }
                else {
                    setMessageNotify({
                        severity: "error",
                        message: "خطا در ورود به باشگاه",
                        open: true
                    });
                }
            }).catch(e => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در ورود به باشگاه",
                    open: true
                });
            });
        }
        else {
            setMessageNotify({
                severity: "warning",
                message: "نام کاربری (شماره تلفن همراه) به صورت صحیح وارد نشده است",
                open: true
            });
        }

    }

    return (
        <>
            <div style={mainDivStyle}>
                <div style={headerDivStyle}></div>
                <div style={headerDivStyle}>
                    <div style={rightHeaderSection}></div>
                    <div style={centerHeaderSection}>
                        <b style={centerHeaderText}>ابزار آلات صنعتی اِن ای سی</b>
                    </div>
                    <div style={leftHeaderSection}></div>
                </div>
                <div style={headerLogoSection}>
                    <div style={headerLogoSideSection}></div>
                    <div style={headerLogoCenterSection}>
                        <img src={headerLogo} style={logoImage} />
                    </div>
                    <div style={headerLogoSideSection}></div>
                </div>
                <div style={headerText}>
                    <p style={headerEnglishText}>PROFETIONAL TOOLS</p>
                    <p style={headerPersianText}><span style={headerPersianTextNumber}>۲۴</span> ماه گارانتی نا محدود</p>
                </div>
                <div style={dreilContainer}>
                    <img style={dreilImage} src={drailLogo} />
                </div>
                <Grid>
                    <div style={paperStyle}>
                        <TextField style={formElementStyle} className={classes.root} onChange={(e) => { setUserName(e.target.value) }} value={userName} placeholder="نام کاربری را وارد کنید" label="نام کاربری" variant="standard" required fullWidth />
                        <TextField style={formElementStyle} className={classes.root} onChange={(e) => { setPassword(e.target.value) }} value={password} placeholder="کلمه عبور را وارد کنید" label="کلمه عبور" variant="standard" type="password" required fullWidth />
                        <Button onClick={loginHandler} style={formElementStyle} type="submit" variant="contained" fullWidth>ورود</Button>
                        <Button style={buttonStyle} onClick={e => { props.history.push('/loginByMobile') }} variant="text" fullWidth>ورود با شماره موبایل</Button>
                    </div>
                </Grid>
                <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
                <div style={{
                    display: 'flex',
                    justifyContent: 'center',
                }}><span style={{ alignSelf: 'flex-end', alignContent: 'center' }}>www.<span style={{ color: 'darkblue' }}>NEC</span>tools.ir</span></div>
            </div>
        </>
    );
}

export default Login;